import { render } from "./HoursDetails.vue?vue&type=template&id=47454a2e&scoped=true"
import script from "./HoursDetails.vue?vue&type=script&lang=js"
export * from "./HoursDetails.vue?vue&type=script&lang=js"

import "./HoursDetails.vue?vue&type=style&index=0&id=47454a2e&scoped=true&lang=scss"
import "./HoursDetails.vue?vue&type=style&index=1&id=47454a2e&lang=scss"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47454a2e"]])

export default __exports__